module.exports = __webpack_public_path__ + "static/media/multi-tenant-saas-logo.a643c294.png";